var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-center mt-5" }, [
    _c("h2", { staticClass: "mt-5 mb-5" }, [
      _vm._v("Welcome to " + _vm._s(_vm.site_name)),
    ]),
    _vm._v(" "),
    _vm.frontend == "frontend.skjersaas"
      ? _c("h6", { staticClass: "mb-10" }, [
          _vm._v(
            "Thank you for choosing " +
              _vm._s(_vm.site_name) +
              ", Oregon's Oldest ski and snowboard shop for your rental needs."
          ),
        ])
      : _c("h6", { staticClass: "mb-10" }, [
          _vm._v(
            "Thank you for choosing " +
              _vm._s(_vm.site_name) +
              " ski and snowboard shop for your rental needs."
          ),
        ]),
    _vm._v(" "),
    _c("h5", { staticClass: "mt-5 mb-5" }, [
      _vm._v("Ready to rent skis and snowboards?"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        !_vm.is_delivery
          ? _c(
              "v-btn",
              { attrs: { color: "primary" }, on: { click: _vm.inShop } },
              [_vm._v("\n            In Shop\n        ")]
            )
          : _vm.delivery
          ? _c(
              "v-btn",
              { attrs: { color: "primary" }, on: { click: _vm.deliveryPage } },
              [_vm._v("\n            Delivery\n        ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }